
import FormPersonalData from '@/components/forms/FormPersonalData.vue';
import { toSnackCase } from '@/helpers/api';
import FormStore from '@/store/formStore';
import {
  ConfigInterface, CustomerPersonData, FormType, InvestmentPersonData, SetPersonField,
} from '@/store/types';
import { VFormInterface } from '@/types';
import { Component, Ref, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

const INIT_DATA: Partial<CustomerPersonData | InvestmentPersonData> = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  birthNumber: '',
  permanentAddress: {
    whole_address: '',
  },
  identityCard: '',
  selfEmployedCompany: '',
};

@Component({
  components: { FormPersonalData },
})
export default class CreateDebtorDialog extends Vue {
  // REFS
  @Ref() readonly form!: VFormInterface;

  // VUEX MODULES
  formStore: FormStore | null = null;

  // DATA
  dialog = false;

  FormType = FormType;

  debtor: Partial<CustomerPersonData | InvestmentPersonData> = { ...INIT_DATA };

  showSelfEmployedId = false;

  config: ConfigInterface = {
    firstName: {
      required: true,
    },
    lastName: {
      required: true,
    },
    email: {
      required: true,
    },
    birthNumber: {
      required: true,
    },
    permanentAddress: {
      required: true,
    },
    identityCard: {
      required: true,
    },
  };

  // HOOKS
  created() {
    this.formStore = getModule(FormStore);
  }

  // METHODS
  setDebtorField({ field, value }: SetPersonField) {
    this.debtor[field] = value;
  }

  closeDialog() {
    this.dialog = false;
    this.$nextTick(() => {
      this.debtor = { ...INIT_DATA };
    });
  }

  async submit() {
    if (!this.form.validate()) return;

    this.formStore.startLoading();

    try {
      const { selfEmployedCompany = '', phoneE164, ...debtor } = this.debtor as InvestmentPersonData;

      const data = toSnackCase({
        ...debtor,
        phone: phoneE164,
        companyId: selfEmployedCompany,
      });

      await this.formStore.createDebtor(data);

      this.formStore.getForm();

      this.debtor = INIT_DATA;

      this.closeDialog();

      this.$toast.success(this.$t('debtors.dialog.success'));
    } catch (e) {
      const {
        identity_card_invalid: identityCardInvalid,
        birth_number: birthNumber,
        detail,
      } = await e.json?.() ?? {};

      if (detail?.includes('not found')) this.$toast.error(this.$t('debtors.dialog.errors.companyIdNotFound', { companyId: (this.debtor as InvestmentPersonData)?.selfEmployedCompany || '' }));
      else if (identityCardInvalid) this.$toast.error(this.$t('debtors.dialog.errors.identityCardInvalid').toString());
      else if (birthNumber) this.$toast.error(this.$t('debtors.dialog.errors.birthNumber').toString());
      else this.$toast.error(this.$t('debtors.dialog.errors.default').toString());
    }

    this.formStore.stopLoading();
  }

  // WATCHERS
}
